<form
  [formGroup]="addProductTypeForm"
  (ngSubmit)="onAddProductType()"
  #pTypeForm
>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !addProductTypeForm.valid }"
        [disabled]="!addProductTypeForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj tip</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <section *ngFor="let pType of getControls(); let i = index">
            <div class="field" [formGroupName]="i">
              <label> {{ i + 1 }}. Naziv tipa</label>
              <section class="flex align-items-center">
                <input type="text" formControlName="name" pInputText />
                <button
                  class="second-btn small-btn ml-3"
                  type="button"
                  pTooltip="Izbriši"
                  tooltipPosition="top"
                  (click)="removeProductType(i)"
                  *ngIf="!(addProductTypeForm.length == 1)"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </section>
            </div>
          </section>
          <button
            class="second-btn mt-3"
            type="button"
            (click)="addProductType()"
          >
            Dodaj tip
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
